import { mapGetters, mapActions } from 'vuex';
import { GcLoader } from '@garmin/components-global';
import ProductList from '@/components/ProductList/index.vue';
import PriceText from '@/components/PriceText/index.vue';

export default {
  name: 'AccessoriesSection',
  data() {
    return {
      className: 'app__product__accessories__section',
      defaultQuantity: 1,
    };
  },
  props: {
    categoryName: {
      type: String,
    },
  },
  components: {
    ProductList,
    PriceText,
    GcLoader,
  },
  computed: {
    dataUaEvent() {
      if (this.categoryName) {
        const name = this.categoryName
          .replace(',', '')
          .replace(' & ', ' ')
          .replace(' and ', ' ');
        return `Product Page, Accessories, ${name}`;
      }
      return undefined;
    },
    ...mapGetters({
      showSections: 'getShowSections',
      accessoriesTabError: 'getAccessoriesTabError',
      accessoriesByCategory: 'getActiveAccessoriesByCategory',
      tabNoAccessories: 'getTabNoAccessories',
      addToCart: 'getAddToCart',
      expandSectionText: 'getExpandSection',
      collapseSectionText: 'getCollapseSection',
      saveText: 'getPriceSaveText',
      vatToolTip: 'getVatToolTip',
      showVatToolTip: 'getShowVatToolTip',
    }),
  },
  methods: {
    ...mapActions([
      'setSection',
    ]),
    sectionClass(categoryName) {
      return this.showSections[categoryName] ? `${this.className}__accordion__button--show`
        : `${this.className}__accordion__button`;
    },
    getPriceObj(product) {
      return product.priceObj;
    },
    getSavings(product) {
      return this.getPriceObj(product).savings;
    },
    getSalePrice(product) {
      return this.getPriceObj(product).salePrice;
    },
    getPrice(product) {
      return this.getPriceObj(product).price;
    },
    getSellable(product) {
      return this.getPriceObj(product).sellable;
    },
    getPriceIsLoading(product) {
      const priceObj = this.getPriceObj(product);
      return !(priceObj && priceObj.priceLoaded);
    },
    getPartNumber(product) {
      return product.partNumber;
    },
    showAddToCart(product) {
      return this.getPrice(product) && this.getSellable(product);
    },
    getAddToCartNewLink(product) {
      return product.addToCartLink;
    },
    showAddToCartNew(product) {
      return this.getAddToCartNewLink(product) && this.showAddToCart(product);
    },
    getAddToCartOldLink(product) {
      return product.addToCartUrlOld;
    },
    showAddToCartOld(product) {
      return this.getAddToCartOldLink(product) && this.showAddToCart(product);
    },
    showVatToolTipEl(product) {
      return this.showVatToolTip && this.getPrice(product);
    },
  },
};
